import React from 'react';
import DOMPurify from 'dompurify';

export default ({ containerSlug, formSlug }) => {
  let link = window.location.origin + '/' + containerSlug;
  if (formSlug) {
    link = link + '/' + formSlug;
  }
  const permalink = DOMPurify.sanitize(link);

  return (
    <div className='row'>
      <div className='name'>Permalink:</div>
      <div className='value p-link'>
        <a target='_blank' href={permalink} rel='noreferrer noopener'>
          {permalink}
        </a>
      </div>
    </div>
  );
};
